// export const BASE_API_URL = 'https://nodeapi.tueducaciondigital.site/'
//export const BASE_API_URL = 'http://localhost:3002/'
const BASE_URL_API_OPS = 'pulpoia-ops.com/backend/nodeapi/';

const BASE_URL_API_DEV = 'localhost';
const BACKEND_PORT = "3002"
const PROTOCOL = window.location.protocol;
export const HOST = PROTOCOL === 'https:' ? `${BASE_URL_API_OPS}` : `${BASE_URL_API_DEV}:${BACKEND_PORT}`;
export const BASE_URL_API = `${window.location.protocol}//${HOST}/`;
//export const BASE_API_URL = `${window.location.protocol}//${HOST}/`;


export const BASE_API_URL = `https://pulpoia-ops.com/backend/nodeapi/`;
//export const BASE_API_URL = `http://localhost:3002/`;

export const URL_API_USER_TRACK = `https://pulpoia-ops.com/backend/nodeapi/usertrack`;

export const NAME_HEADER_AUTH = "P-CS";

export const API = Object.freeze({
    USER_CATEGORY: BASE_API_URL + 'usercategory',
    AD: 'https://test.tueducaciondigital.site/ad',
    DASHBOARD: BASE_API_URL + 'dashboard',
    LOAD_COMBO: BASE_API_URL + 'loadCombo/',
    OFFER_FOLLOW: BASE_API_URL + 'offersFollow/',
    OFFER_TRACKING_CHART: BASE_API_URL + 'getOffersTrackingChart?OffersFollo_ID=%1s&TrafficSrc=%2s',
})
// https://nodeapi.tueducaciondigital.site/getOffersTrackingChart?OffersFollo_ID=42d6a8f0-fdef-11ef-8022-3d053d0ab89a&TrafficSrc=Domain

/**
 * Tooltips o textos de ayuda.
 * @type {Readonly<{TOOLBAR_SLIDER: string}>}
 */
export const TOOLTIPS = Object.freeze({
    TOOLBAR_SLIDER: "Desplace hacia la derecha para aumentar el número de anuncios duplicados que quiere encontrar"
})
/**
 * Códigos de status para los anuncios que se usan en el servidor para filtrar los datos.
 * @type {Readonly<{ACTIVE: string, INACTIVE: string, NONE: string, ANY: string}>}
 */
export const STATUS_ADS_CODES = Object.freeze({
    ACTIVOS: "ACTIVE",
    INACTIVOS: "INACTIVE",
    ACTIVOS_E_INACTIVOS: "ANY",
    ANUNCIOS_SEGUIDOS: "FOLLOW",
    TODOS: "ALL"
})
export const STATUS_ADS_DESC = Object.freeze({
    ACTIVOS: "Activos",
    INACTIVOS: "Inactivos",
    ACTIVOS_E_INACTIVOS: "Activos e inactivos",
    ANUNCIOS_SEGUIDOS: "Anuncios seguidos",
    TODOS: "Todos"
})